__turbopack_context__.v({
  "className": "roboto_2a65b865-module__VGIKxG__className",
});
